import { DateTime } from 'luxon';

import { termsOfUse } from 'theSource/assets';
import { getTermsOfUseLocalStorageKey } from 'theSource/features/TermsOfUse/utils';
import { TermsOfUseLocalDetails } from 'theSource/features';

export const isTermsOfUseAgreementValidInLocalStorage = (
  subscriberId: number,
  thresholdDays: number
): boolean => {
  // Note: Remove this feature flag entirely when back-end becomes live 24/7
  if (process.env.REACT_APP_DISABLE_TERMS_OF_USE === 'true') {
    return true;
  }

  const storedAgreementString = localStorage.getItem(
    getTermsOfUseLocalStorageKey(subscriberId)
  );

  if (!storedAgreementString) {
    return false;
  }

  const storedAgreement: TermsOfUseLocalDetails = JSON.parse(
    storedAgreementString
  );

  return (
    isNewestVersion(storedAgreement.version) &&
    isLastCheckBelowThreshold(storedAgreement.checked, thresholdDays)
  );
};

const isNewestVersion = (storedVersion: String): boolean =>
  storedVersion === termsOfUse.version;

const isLastCheckBelowThreshold = (
  lastCheck: string,
  thresholdDays: number
): boolean => {
  if (!lastCheck) {
    return false;
  }

  const validUntil = DateTime.fromISO(lastCheck).plus({
    days: thresholdDays,
  });

  if (!validUntil.isValid) {
    return false;
  }

  if (validUntil.diff(DateTime.now()).milliseconds > 0) {
    return true;
  }

  return false;
};
